import React from 'react';
import { IVideoBlockFullwidthFields } from '../../../types/contentful';

import { useWindowSize } from '../../hooks/useWindowSize';
import cx from 'classnames';

interface Props {
  mobileButtonStyle: IVideoBlockFullwidthFields['mobileButtonStyle'];
  desktopButtonStyle: IVideoBlockFullwidthFields['desktopButtonStyle'];
  toggleVideo: Function;
}

export function VideoContainerContent({
  mobileButtonStyle,
  desktopButtonStyle,
  toggleVideo
}: Props) {
  const windowSize = useWindowSize();

  return (
    <button
      id="gl-video-play-button"
      onClick={(e) => {
        toggleVideo(true);
        e.currentTarget.blur();
      }}
      aria-label="Play video"
      className="z-[1] outline-0 absolute left-0 right-0 top-0 bottom-0 m-auto w-full flex flex-col justify-center items-center border-0 appearance-none -webkit-appearance-none p-0 cursor-pointer bg-transparent [&_.playIconBackground]:transition-[fill_0.2s_ease] [&_.playIconCenter]:transition-[fill_0.2s_ease] hover:[&_.playIconBackground]:fill-[#80D6B0] focus:[&_.playIconBackground]:fill-[#80D6B0] hover:[&_.playIconCenter]:fill-[#035C67] focus:[&_.playIconCenter]:fill-[#035C67]"
    >
      {
        // original functionality
        (!mobileButtonStyle ||
          !desktopButtonStyle ||
          mobileButtonStyle === 'Large Centered' ||
          desktopButtonStyle === 'Large Centered') && (
          <svg
            width="221"
            height="221"
            viewBox="0 0 221 221"
            aria-hidden="true"
            className="cursor-pointer h-[40%] w-full max-w-full"
          >
            <path
              className="playIconBackground"
              d="M0 56C0 25.072 25.0721 0 56 0H164.482C195.41 0 220.482 25.0721 220.482 56V164.482C220.482 195.41 195.41 220.482 164.482 220.482H56C25.072 220.482 0 195.41 0 164.482V56Z"
              fill="#035C67"
            />
            <path
              className="playIconCenter"
              d="M145.086 102.266C150.419 105.345 150.419 113.043 145.086 116.123L97.2475 143.742C91.9141 146.821 85.2474 142.972 85.2474 136.814L85.2475 81.5748C85.2475 75.4164 91.9141 71.5674 97.2475 74.6466L145.086 102.266Z"
              fill="#80D6B0"
            />
          </svg>
        )
      }

      {mobileButtonStyle === 'Small Centered' && windowSize === 'mobile' && (
        <svg
          width="80"
          height="80"
          aria-hidden="true"
          className="cursor-pointer max-w-full"
        >
          <path
            opacity="0.8"
            d="M0 24C0 10.7452 10.7452 0 24 0H56C69.2548 0 80 10.7452 80 24V56C80 69.2548 69.2548 80 56 80H24C10.7452 80 0 69.2548 0 56V24Z"
            fill="#1D252C"
          />
          <path
            d="M49.666 37.9349C50.9993 38.7047 50.9993 40.6292 49.666 41.399L36.166 49.1933C34.8327 49.9631 33.166 49.0008 33.166 47.4612L33.166 31.8728C33.166 30.3332 34.8327 29.3709 36.166 30.1407L49.666 37.9349Z"
            fill="#00D9B4"
          />
        </svg>
      )}

      {mobileButtonStyle === 'Small Bottom Left' && windowSize === 'mobile' && (
        <svg
          width="56"
          height="56"
          aria-hidden="true"
          className={cx(
            'cursor-pointer max-w-full absolute',
            'left-[3rem] bottom-[3rem]',
            'min-[320px]:left-[3rem] min-[320px]:bottom-[3rem]',
            'mobile:left-[3rem] mobile:bottom-[3rem]',
            'tablet:left-[3rem] tablet:bottom-[3rem]',
            'desktop:left-[5.0625rem] desktop:bottom-[5.125rem]'
          )}
        >
          <path
            opacity="0.8"
            d="M0 16.8C0 7.52162 7.52162 0 16.8 0H39.2C48.4784 0 56 7.52162 56 16.8V39.2C56 48.4784 48.4784 56 39.2 56H16.8C7.52162 56 0 48.4784 0 39.2V16.8Z"
            fill="#1D252C"
          />
          <path
            d="M34.7672 26.5546C35.7005 27.0934 35.7005 28.4406 34.7672 28.9794L25.3172 34.4354C24.3839 34.9742 23.2172 34.3007 23.2172 33.223L23.2172 22.311C23.2172 21.2333 24.3839 20.5597 25.3172 21.0986L34.7672 26.5546Z"
            fill="#00D9B4"
          />
        </svg>
      )}

      {desktopButtonStyle === 'Small Bottom Left' &&
        windowSize === 'tablet' && (
          <svg
            width="56"
            height="56"
            aria-hidden="true"
            className={cx(
              'cursor-pointer max-w-full absolute',
              'left-[3rem] bottom-[3rem]',
              'min-[320px]:left-[3rem] min-[320px]:bottom-[3rem]',
              'mobile:left-[3rem] mobile:bottom-[3rem]',
              'tablet:left-[3rem] tablet:bottom-[3rem]',
              'desktop:left-[5.0625rem] desktop:bottom-[5.125rem]'
            )}
          >
            <path
              opacity="0.8"
              d="M0 16.8C0 7.52162 7.52162 0 16.8 0H39.2C48.4784 0 56 7.52162 56 16.8V39.2C56 48.4784 48.4784 56 39.2 56H16.8C7.52162 56 0 48.4784 0 39.2V16.8Z"
              fill="#1D252C"
            />
            <path
              d="M34.7672 26.5546C35.7005 27.0934 35.7005 28.4406 34.7672 28.9794L25.3172 34.4354C24.3839 34.9742 23.2172 34.3007 23.2172 33.223L23.2172 22.311C23.2172 21.2333 24.3839 20.5597 25.3172 21.0986L34.7672 26.5546Z"
              fill="#00D9B4"
            />
          </svg>
        )}

      {desktopButtonStyle === 'Small Bottom Left' &&
        windowSize === 'desktop' && (
          <svg
            width="80"
            height="80"
            aria-hidden="true"
            className={cx(
              'cursor-pointer max-w-full absolute',
              'left-[3rem] bottom-[3rem]',
              'min-[320px]:left-[3rem] min-[320px]:bottom-[3rem]',
              'mobile:left-[3rem] mobile:bottom-[3rem]',
              'tablet:left-[3rem] tablet:bottom-[3rem]',
              'desktop:left-[5.0625rem] desktop:bottom-[5.125rem]'
            )}
          >
            <path
              opacity="0.8"
              d="M0 24C0 10.7452 10.7452 0 24 0H56C69.2548 0 80 10.7452 80 24V56C80 69.2548 69.2548 80 56 80H24C10.7452 80 0 69.2548 0 56V24Z"
              fill="#1D252C"
            />
            <path
              d="M49.667 37.9349C51.0003 38.7047 51.0003 40.6292 49.667 41.399L36.167 49.1933C34.8337 49.9631 33.167 49.0008 33.167 47.4612L33.167 31.8728C33.167 30.3332 34.8337 29.3709 36.167 30.1407L49.667 37.9349Z"
              fill="#00D9B4"
            />
          </svg>
        )}
    </button>
  );
}
